import React from "react";

import { ClassicTable } from "components/layout";
import { PosSubscriptionServices } from "globalConstants";
import { floatWithComma2Normalizer } from "validators";

type SubscriptionOptionViewProps = {
	subscriptions: any;
};

const SubscriptionOptionView = ({
	subscriptions,
}: SubscriptionOptionViewProps) => {
	const headerItems = [
		{
			row: [
				{
					label: "Service / Hardware:",
				},
				{
					label: "Billing Cadence:",
				},
				{
					label: "Quantity:",
				},
				{
					label: "Cost, $:",
				},
			],
		},
	];

	const getRow = (displayName, service) => {
		return {
			row: [
				{
					value: displayName,
				},
				{
					value: service?.billingCadence?.displayName,
				},
				{
					value: service?.quantity,
				},
				{
					value: floatWithComma2Normalizer(service?.cost || 0),
				},
			],
		};
	};

	const services = [
		PosSubscriptionServices.PosSystem,
		PosSubscriptionServices.MarketingServices,
		PosSubscriptionServices.IpPhoneService,
		PosSubscriptionServices.TapToPay,
		PosSubscriptionServices.SmsService,
		PosSubscriptionServices.SmsMessage,
		PosSubscriptionServices.SmsSetup,
		PosSubscriptionServices.SalonInTheBox,
	];

	const bodyItems = services.map(service => {
		return subscriptions?.hasOwnProperty?.(service?.name) &&
			subscriptions?.[service?.name]?.isSubscribed
			? getRow?.(service?.displayName, subscriptions?.[service?.name])
			: { row: [] };
	});

	return (
		<ClassicTable
			headerItems={headerItems}
			bodyItems={bodyItems}
			borderless
		/>
	);
};

export default SubscriptionOptionView;
